__turbopack_context__.v({
  "dialog": "Hc50iG_dialog",
  "pointer": "Hc50iG_pointer",
});
